export default [
  {
    path: 'settings-documentation',
    meta: { label: 'Settings Documentation' },
    component: {
      render(c) { return c('router-view') }
    },
    children: [
      {
        path: '',
        name: 'settings-documentation',
        meta: {
          label: 'Settings Documentation',
          permission: 'show_settings_documentation'
        },
        component: () => import('./../../views/settings/Documentation'),
      },
    ]
  },
]
